import { ContactDataStepA } from './components/ContactDataStepA'

interface ContactDataStepProps {
  categoryId: string
  onBack: () => void
  transformSubmitValues: (values: any) => any
  onFinish: () => void
  handleCalculationSuccessful: () => void
}

export const ContactDataStep = ({
  categoryId,
  onBack,
  transformSubmitValues,
  onFinish,
  handleCalculationSuccessful,
}: ContactDataStepProps) => {
  return (
    // TODO there's a mismatch between the types of the ContactDataStepA component and the props it accepts
    // leaving it as is for now to avoid breaking changes during ts migration
    <ContactDataStepA
      {...({
        onBack,
        handleCalculationSuccessful,
        transformSubmitValues,
        categoryId,
        onFinish,
      } as any)}
    />
  )
}
